import { type LucideIcon } from "lucide-react"
import { SidebarGroup, SidebarMenu, SidebarMenuButton } from "@/components/ui/sidebar"
import { Link } from "react-router-dom"
import type { UserRole } from "@/shared/entities/users"
import { useAuth } from "@/modules/auth/store"
import { useMemo } from "react"

export interface NavMainItem {
  title: string
  url: string
  icon: LucideIcon
  isActive: boolean
  allowedRoles: UserRole[]
}

interface NavMainProps {
  items: NavMainItem[]
}

export function NavMain({ items }: NavMainProps) {
  const { user } = useAuth()

  const filteredItems = useMemo(() => {
    return items.filter((item) => item.allowedRoles.includes(user?.role))
  }, [user.role])

  return (
    <SidebarGroup>
      <SidebarMenu>
        {filteredItems.map((item) => (
          <Link key={item.url} to={item.url}>
            <SidebarMenuButton
              className="gap-4 [&>svg]:m-[-2px] [&>svg]:size-5"
              asChild
              tooltip={item.title}
            >
              <div className="my-2 flex w-full">
                <item.icon strokeWidth={1.6} />
                <p className="mt-1 text-xs font-medium">{item.title}</p>
              </div>
            </SidebarMenuButton>
          </Link>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
}
